export const COMPANY_PRODUCT_SHOW_RESET = 'COMPANY_PRODUCT_SHOW_RESET'
export const COMPANY_PRODUCT_SHOW_SET_ERROR = 'COMPANY_PRODUCT_SHOW_SET_ERROR'
export const COMPANY_PRODUCT_SHOW_SET_RETRIEVED = 'COMPANY_PRODUCT_SHOW_SET_RETRIEVED'
export const COMPANY_PRODUCT_SHOW_TOGGLE_LOADING = 'COMPANY_PRODUCT_SHOW_TOGGLE_LOADING'
